import { Box, Button, CircularProgress, Grid, TextField, Typography } from '@mui/material'
import FileInput from 'src/Component/FileInput'
import InputField from 'src/Component/InputField'
import SimpleModal from 'src/Component/SimpleModal'
import useAddBranchGym from './useAddBranchGym'
import { Controller } from 'react-hook-form'
import { useLazyGetParentGymsListQuery } from 'src/api/parentGymApi'
import { AsyncPaginate } from 'react-select-async-paginate'

// Custom styles
export const customStylesForAsyncSelect = {
  control: (provided: any, state: { isFocused: boolean }) => {
    return {
      ...provided,
      backgroundColor: '#25272B',
      color: 'white !important',
      border: 'none',
      padding: '6px',
      div: {
        color: 'white !important',
      },
    }
  },
  option: (provided: any, state: { isFocused: any }) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#FF3839' : '#25272B',
    color: 'white',
  }),
}

type AddBranchGymModalProps = {
  open: boolean
  onClose: () => void
  successCallback: () => void
}
const AddBranchGymModal = ({ open, onClose, successCallback }: AddBranchGymModalProps) => {
  const { file, handleFileChange, control, errors, onSubmit, isLoadingAddBranchGym } =
    useAddBranchGym({
      successCallback,
    })

  const [fetchParentsGym, { isFetching: isFetchingParentsGymData }] =
    useLazyGetParentGymsListQuery()

  const loadMoreParentData = async (search: any, loadedOptions: any, { page }: any) => {
    try {
      const response = await fetchParentsGym({
        search,
        page,
        pageSize: 20,
      })
      console.log('Load Parent response', response, loadedOptions)
      if (response.isSuccess && response?.data?.results?.length) {
        console.log('suraj')

        return {
          options: response.data.results.map((row) => {
            return {
              value: row.id,
              label: row.name,
            }
          }),
          hasMore: !!response.data.next,
          additional: {
            page: page + 1,
          },
        }
      }
    } catch (error) {
      console.log(error)
    }

    return {
      options: [],
      hasMore: false,
      additional: {
        page: 1,
      },
    }
  }

  console.log(errors)

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            <FileInput
              type='image'
              title='You can click me to upload files!'
              discription='Support for  image file formats (.png, .jpeg)'
              name='fileuplaod'
              value={file}
              onChange={handleFileChange}
              showPreview
            />
            <Grid container mt={2}>
              <Grid xs={8}>
                <Grid container>
                  <Grid container mb={2}>
                    <Grid xs={4}>
                      <Typography
                        style={{
                          color: 'white',
                          fontWeight: 'bold',
                          fontSize: '15px',
                        }}
                      >
                        Parent Gym <span style={{ color: 'red', fontSize: '12px' }}>*</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid xs={8}>
                      <Controller
                        name='parentGym'
                        control={control}
                        rules={{ required: true }}
                        render={({ field }) => (
                          <>
                            <AsyncPaginate
                              styles={customStylesForAsyncSelect}
                              name={field.name}
                              id={field.name}
                              value={field.value}
                              placeholder='Choose Parent Gym'
                              loadOptions={loadMoreParentData}
                              onChange={field.onChange}
                              additional={{
                                page: 1,
                              }}
                            />
                            {!!errors.parentGym?.value && (
                              <Grid container justifyContent='right'>
                                <Typography variant='subtitle2' color='red' textAlign='right'>
                                  {errors.parentGym.value.message}
                                </Typography>
                              </Grid>
                            )}
                          </>
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container mb={2}>
              <Grid xs={8}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter gym name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.name.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='about'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='about'
                        placeholder='Enter gym about'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.about}
                        required
                        multiline
                        rows={3}
                      />
                      {!!errors.about && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.about.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='address'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Address'
                        placeholder='Enter park address'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.address}
                        required
                      />
                      {!!errors.address && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.address.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='latitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Latitude'
                        placeholder='Enter park latitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.latitude}
                        required
                      />
                      {!!errors.latitude && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.latitude.type === 'typeError'
                              ? 'Latitude shoule be number'
                              : errors.latitude.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='longitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Longitude'
                        placeholder='Enter park longitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.longitude}
                        required
                      />
                      {!!errors.longitude && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.longitude.type === 'typeError'
                              ? 'Longitude shoule be number'
                              : errors.longitude.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='rating'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='rating'
                        placeholder='Enter park rating'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.rating}
                        required
                      />
                      {!!errors.rating && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.rating.type === 'typeError'
                              ? 'rating shoule be number'
                              : errors.rating.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='open'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Open At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.open}
                        required
                      />
                      {!!errors.open && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.open.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='close'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Close At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.close}
                        required
                      />
                      {!!errors.close && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.close.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Button
              variant='contained'
              color='primary'
              type='submit'
              disabled={isLoadingAddBranchGym}
            >
              {isLoadingAddBranchGym ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default AddBranchGymModal
